var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Group } from '@/models/Group';
import { Component, Vue, Prop } from 'vue-property-decorator';
import ActionsMenu from '@/components/ActionsMenu/ActionsMenu.vue';
import ManageGoalPlannerNoteDialog from '@/views/Groups/Tabs/GoalPlanner/ManageGoalPlannerNoteDialog/ManageGoalPlannerNoteDialog.vue';
import { DateTime } from 'luxon';
let BirthdayList = class BirthdayList extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    getNewAge(dateOfBirth) {
        const birthDate = DateTime.fromISO(dateOfBirth);
        const today = DateTime.local();
        // Calculate base age
        let age = today.year - birthDate.year;
        // Birthday this year
        const birthdayThisYear = birthDate.set({ year: today.year });
        // If birthday hasn't happened yet this year, subtract 1 from age
        if (today < birthdayThisYear) {
            age -= 1;
        }
        return age;
    }
    getFormattedDate(date) {
        const dateObject = DateTime.fromISO(date);
        return dateObject.toFormat('d-M-y');
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get filteredUsersBasedOnBirthday() {
        if (!this.group.users || !Array.isArray(this.group.users)) {
            return [];
        }
        const activeDate = DateTime.fromISO(this.date);
        if (!activeDate.isValid) {
            return [];
        }
        return this.group.users.filter((user) => {
            const userDob = DateTime.fromISO(user.dob);
            if (!userDob.isValid) {
                return false;
            }
            return userDob.month === activeDate.month && userDob.day === activeDate.day;
        });
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], BirthdayList.prototype, "group", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], BirthdayList.prototype, "date", void 0);
BirthdayList = __decorate([
    Component({
        components: {
            ActionsMenu,
            ManageGoalPlannerNoteDialog,
        },
    })
], BirthdayList);
export default BirthdayList;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
